<template>
  <section class="section">
    <div class="container box">
      <!-- Enhanced Dashboard Header -->
      <div class="dashboard-header">
        <h1 class="title">
          <b-icon icon="briefcase" class="has-text-primary"/>
          Company Trips Dashboard
        </h1>
      </div>

      <!-- Tabs for different views -->
      <div class="tabs is-boxed">
        <ul class="m-0">
          <li :class="{ 'is-active': activeTab === 'all' }">
            <a @click="setActiveTab('all')">
              <span class="icon is-small"><i class="fas fa-list"></i></span>
              <span>All Trips</span>
              <b-tag
                v-if="pendingCount"
                type="is-info"
                size="is-small"
                class="ml-2"
                >{{ pendingCountText }}</b-tag
              >
            </a>
          </li>
          <!-- <li :class="{ 'is-active': activeTab === 'pending' }">
            <a @click="setActiveTab('pending')">
              <span class="icon is-small"><i class="fas fa-clock"></i></span>
              <span>Pending Approval</span>
              <b-tag
                v-if="pendingCount"
                type="is-warning"
                size="is-small"
                class="ml-2"
                >{{ pendingCount }}</b-tag
              >
            </a>
          </li> -->
          
          <li :class="{ 'is-active': activeTab === 'reports' }">
            <a @click="setActiveTab('reports')">
              <span class="icon is-small"
                ><i class="fas fa-chart-bar"></i
              ></span>
              <span>Reports</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Error message -->
      <b-message v-if="error" type="is-danger" has-icon>
        {{ error }}
      </b-message>

      <!-- Loading indicator -->
      <b-loading :is-full-page="false" :active="loading" />

      <!-- Tab Content with transition -->
      <transition-group
        name="tab-transition"
        tag="div"
        class="tab-content-container"
      >
        <!-- Pending Trips Tab Content -->
        <div v-if="activeTab === 'pending'" key="pending-trips">
          <h2 class="subtitle">Trips Pending Approval</h2>

          <!-- Enhanced Empty State -->
          <div v-if="pendingTrips.length === 0 && !loading" class="empty-state">
            <span class="icon">
              <i class="fas fa-check-circle"></i>
            </span>
            <p class="empty-state-message">
              No pending trips found. All trip requests are up to date.
            </p>
          </div>

          <div v-else class="table-container">
            <b-table
              :data="pendingTrips"
              :striped="true"
              :hoverable="true"
              :paginated="pendingTrips.length > 10"
              :per-page="10"
              default-sort="created_at"
              default-sort-direction="desc"
            >

              <b-table-column
                field="created_at"
                label="Date Booked"
                sortable
                centered
              >
                <template v-slot:default="props">
                  {{ formatDate(props.row.created_at) }}
                </template>
              </b-table-column>

              <b-table-column
                field="traveler"
                label="Traveler"
                sortable
                searchable
              >
                <template v-slot:default="props">
                  {{ props.row.firstName }} {{ props.row.lastName }}
                </template>
              </b-table-column>

              <b-table-column field="pnr" label="Record Locator" sortable searchable>
                <template v-slot:default="props">
                  <!-- <span
                    v-if="props.row.isMeeting"
                    class="icon has-text-info ml-2"
                    title="Meeting Trip"
                  >
                    <i class="fas fa-handshake"></i>
                  </span> -->
                  {{ props.row.pnr }}
                </template>
              </b-table-column>



              <b-table-column
                field="policy.triggered"
                label="Policy"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    :type="getPolicyStatusType(props.row.policy)"
                  >
                    {{ getPolicyStatus(props.row.policy) }}
                  </b-tag>
                </template>
              </b-table-column>


              <b-table-column
                field="policy.triggered"
                label="Approval"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag v-if="getApprovalStatus(props.row)"
                    :type="getApprovalStatusType(props.row)"
                  >
                    {{ getApprovalStatus(props.row) }}
                  </b-tag>
                  <span v-else>
                    
                    <b-button
                      size="is-small"
                      type="is-text"
                      
                      @click="goToReviewPage(props.row)"
                    >
                      Review Trip
                    </b-button>
                  </span>
                </template>
              </b-table-column>

              <!-- <b-table-column
                field="policy.mostStrictApprovalRequired"
                label="Approval Level"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    v-if="props.row.policy.mostStrictApprovalRequired"
                    :type="
                      getApprovalLevelType(
                        props.row.policy.mostStrictApprovalRequired
                      )
                    "
                  >
                    {{
                      $helpers.capitalize(
                        props.row.policy.mostStrictApprovalRequired
                      ) || "N/A"
                    }}
                  </b-tag>
                  <span v-else>N/A</span>
                </template>
              </b-table-column> -->

              <!-- <b-table-column
                field="reviewed_by"
                label="Reviewed By"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <span>{{ props.row.reviewed_by }}</span>
                </template>
              </b-table-column> -->

              

              <b-table-column label="Actions" centered>
                <template v-slot:default="props">
                  <div class="buttons is-centered">
                    <b-button
                      size="is-small"
                      type="is-text"
                      icon-left=""
                      @click="goToReviewPage(props.row)"
                    >
                      View Trip
                    </b-button>
                  </div>
                </template>
              </b-table-column>
              <!--- -->

              

              <!-- <b-table-column
                field="policy.mostStrictApprovalRequired"
                label="Approval Level"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    :type="
                      getApprovalLevelType(
                        props.row.policy.mostStrictApprovalRequired
                      )
                    "
                  >
                    {{
                      $helpers.capitalize(
                        props.row.policy.mostStrictApprovalRequired
                      ) || "N/A"
                    }}
                  </b-tag>
                </template>
              </b-table-column>

              <b-table-column
                field="policy.rulesTriggered.length"
                label="Rules Triggered"
                centered
                sortable
              >
                <template v-slot:default="props">
                  <span v-if="props.row.policy.rulesTriggered.length > 0">
                    {{ props.row.policy.rulesTriggered.length }}
                    <b-tooltip
                      :label="getRulesSummary(props.row.policy.rulesTriggered)"
                      multilined
                      position="is-top"
                    >
                      <b-icon icon="info-circle" size="is-small"></b-icon>
                    </b-tooltip>
                  </span>
                  <span v-else>0</span>
                </template>
              </b-table-column>

              

              <b-table-column label="Actions" centered>
                <template v-slot:default="props">
                  <div class="buttons is-centered">
                    <b-button
                      size="is-small"
                      type="is-primary"
                      icon-left="eye"
                      @click="goToReviewPage(props.row)"
                    >
                      Review
                    </b-button>
                  </div>
                </template>
              </b-table-column>-->
            </b-table>
          </div>
        </div>

        <!-- All Trips Tab Content -->
        <div v-if="activeTab === 'all'" key="all-trips">
          <h2 class="subtitle">All Trips</h2>

          <!-- Enhanced Filter Panel -->
          <div class="filter-panel">
            <b-field grouped group-multiline>
              <b-field label="Status">
                <b-select v-model="filters.status" placeholder="All Statuses">
                  <option value="">All Statuses</option>
                  <option value="pending">Pending Approval</option>
                  <option value="approved">Approved</option>
                  <option value="denied">Denied</option>
                </b-select>
              </b-field>

              <b-field label="Policy">
                <b-select v-model="filters.policyCompliance" placeholder="All">
                  <option value="">All</option>
                  <option value="compliant">In Policy</option>
                  <option value="non-compliant">Out of Policy</option>
                </b-select>
              </b-field>

              <b-field label="Traveler">
                <b-autocomplete
                  v-model="filters.travelerName"
                  :data="filteredTravelerNames"
                  placeholder="Search traveler..."
                  field="name"
                  @typing="filterTravelerNames"
                  @select="
                    (option) =>
                      (filters.travelerName = option ? option.name : '')
                  "
                  clearable
                ></b-autocomplete>
              </b-field>

              <b-field label="Booking Date">
                <b-datepicker
                  v-model="filters.dateRange"
                  range
                  placeholder="Select date range"
                  icon="calendar-alt"
                  :multiple="true"
                  :max-date="maxDate"
                  :mobileNative="false"
                  :nearby-selectable-month-days="true"
                  :events="[]"
                  indicators="bars"
                ></b-datepicker>
              </b-field>


              <div class="buttons is-right mt-5">
                <b-button
                  type="is-text"
                  size="is-small"
                  icon-left="filter"
                  @click="applyFilters"
                >
                  Apply Filters
                </b-button>
                <b-button type="is-text" size="is-small" @click="resetFilters">
                  Reset
                </b-button>
              </div>

            </b-field>

            
          </div>

          <!-- Enhanced Empty State -->
          <div
            v-if="filteredTrips.length === 0 && !loading"
            class="empty-state"
          >
            <span class="icon">
              <i class="fas fa-search"></i>
            </span>
            <p class="empty-state-message">
              No trips found matching your criteria. Try adjusting your filters.
            </p>
            <b-button type="is-light" @click="resetFilters"
              >Reset Filters</b-button
            >
          </div>

          <div v-else class="table-container pb-5">
            <b-table
              :data="filteredTrips"
              :striped="true"
              :hoverable="true"
              :paginated="filteredTrips.length > 10"
              :per-page="10"
              :sort-icon="sortIcon"
              :sort-icon-size="sortIconSize"
              default-sort="created_at"
              default-sort-direction="desc"
            >
              
              <b-table-column
                field="created_at"
                label="Booking Date"
                sortable
                
              >
                <template v-slot:default="props">
                  {{ formatDate(props.row.created_at) }}
                </template>
              </b-table-column>

              <b-table-column field="traveler" label="Traveler">
                <template v-slot:default="props">
                  {{ props.row.firstName }} {{ props.row.lastName }}
                </template>
              </b-table-column>

              <b-table-column field="pnr" label="Record Locator" sortable>
                <template v-slot:default="props">
                  <!-- <span
                    v-if="props.row.isMeeting"
                    class="icon has-text-info ml-2"
                    title="Meeting Trip"
                  >
                    <i class="fas fa-handshake"></i>
                  </span> -->
                  {{ props.row.pnr }}
                </template>
              </b-table-column>

              <!-- <b-table-column field="status" label="Status" sortable centered>
                <template v-slot:default="props">
                  <b-tag :type="getRowStatusType(props.row)">
                    {{ getRowStatusText(props.row) }}
                  </b-tag>
                </template>
              </b-table-column> -->

              <!-- <b-table-column
                field="policy.triggered"
                label="Policy Compliance"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    :type="getPolicyComplianceType(props.row.policy.triggered)"
                  >
                    {{ getPolicyComplianceText(props.row.policy.triggered) }}

                    {{ getPolicyStatus(props.row.policy) }}
                  </b-tag>
                </template>
              </b-table-column> -->

              <b-table-column
                field="policy.triggered"
                label="Policy"
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    :type="getPolicyStatusType(props.row.policy)"
                  >
                    {{ getPolicyStatus(props.row.policy) }}
                  </b-tag>
                </template>
              </b-table-column>


              <b-table-column
                field="policy.triggered"
                label="Approval"
                centered
              >
                <template v-slot:default="props">
                  <b-tag v-if="getApprovalStatus(props.row)"
                    :type="getApprovalStatusType(props.row)"
                  >
                    {{ getApprovalStatus(props.row) }}
                  </b-tag>
                  <span v-else-if="canBeReviewed(props.row)">
                    <b-button
                      size="is-small"
                      type="is-text"
                      
                      @click="goToReviewPage(props.row)"
                    >
                      Review Trip
                    </b-button>
                  </span>
                </template>
              </b-table-column>

              <!-- <b-table-column
                field="policy.mostStrictApprovalRequired"
                label="Approval Level"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <b-tag
                    v-if="props.row.policy.mostStrictApprovalRequired"
                    :type="
                      getApprovalLevelType(
                        props.row.policy.mostStrictApprovalRequired
                      )
                    "
                  >
                    {{
                      $helpers.capitalize(
                        props.row.policy.mostStrictApprovalRequired
                      ) || "N/A"
                    }}
                  </b-tag>
                  <span v-else>N/A</span>
                </template>
              </b-table-column> -->

              <!-- <b-table-column
                field="reviewed_by"
                label="Reviewed By"
                sortable
                centered
              >
                <template v-slot:default="props">
                  <span>{{ props.row.reviewed_by }}</span>
                </template>
              </b-table-column> -->

              

              <b-table-column label="Actions" centered>
                <template v-slot:default="props">
                  <div class="buttons is-centered">
                    <b-button
                      size="is-small"
                      type="is-text"
                      icon-left=""
                      @click="goToReviewPage(props.row)"
                    >
                      View Trip
                    </b-button>
                  </div>
                </template>
              </b-table-column>
            </b-table>
          </div>
        </div>

        <!-- Reports Tab Content -->
        <div
          v-if="activeTab === 'reports'"
          key="reports"
          class="reports-section"
        >
          <trip-reports :trips="trips" :loading="loading" />
        </div>
      </transition-group>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import TripReports from "@/components/TripLibrary/TripReports.vue";
import router from "@/router";

export default {
  name: "TripDashboard",
  components: {
    TripReports,
  },
  data() {
    return {
      loading: false,
      error: null,
      trips: [],
      activeTab: "all",

      // Table display
      sortIcon: "arrow-up",
      sortIconSize: "is-small",

      maxDate: new Date(), // Current date for datepicker

      // Filters
      filters: {
        status: "",
        policyCompliance: "",
        travelerName: "",
        dateRange: [],
      },

      // Autocomplete
      travelerNames: [],
      filteredTravelerOptions: [],
    };
  },
  computed: {
    profile() {
      return this.$globals.profile;
    },

    pendingTrips() {
      return this.trips.filter(
        (trip) =>
          !trip.reviewed_at &&
          trip.policy.triggered === "Y" &&
          trip.policy?.mostStrictApprovalRequired != 'none'
      );
    },

    pendingCount() {
      return this.pendingTrips.length;
    },

    pendingCountText() {
      return this.pendingTrips.length + ' pending approval';
    },

    filteredTrips() {
      let result = [...this.trips];

      // Apply status filter
      if (this.filters.status) {
        if (this.filters.status === "pending") {
          // Pending approval: policy triggered but not yet reviewed
          result = result.filter(
            (trip) =>
              !trip.reviewed_at &&
              trip.policy.triggered === "Y" &&
              trip.policy.mostStrictApprovalRequired
          );
        } else if (this.filters.status === "approved") {
          // Approved: has approved_at date
          result = result.filter((trip) => trip.approved_at);
        } else if (this.filters.status === "denied") {
          // Denied: has reviewed_at but no approved_at
          result = result.filter((trip) => trip.denied_at);
        }
      }

      // Apply policy compliance filter
      if (this.filters.policyCompliance) {
        const isCompliant = this.filters.policyCompliance === "compliant";
        result = result.filter((trip) =>
          isCompliant
            ? trip.policy.triggered != "Y"
            : trip.policy.triggered === "Y"
        );
      }

      // Apply traveler name filter
      if (this.filters.travelerName) {
        result = result.filter((trip) => {
          const fullName = `${trip.firstName} ${trip.lastName}`.toLowerCase();
          return fullName.includes(this.filters.travelerName.toLowerCase());
        });
      }

      // Apply date range filter
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        const startDate = moment(this.filters.dateRange[0]).startOf("day");
        const endDate = moment(this.filters.dateRange[1]).endOf("day");

        result = result.filter((trip) => {
          const tripDate = moment(trip.created_at);
          return tripDate.isBetween(startDate, endDate, null, "[]");
        });
      }

      return result;
    },

    filteredTravelerNames() {
      return this.filteredTravelerOptions;
    },
  },
  methods: {
    async getCompanyTrips() {
      this.loading = true;
      this.error = null;
      this.trips = [];

      const accountNumber = this.profile?.account?.gantAccountNumber;
      const contactId = this.profile?.id;

      if (!accountNumber || !contactId) {
        this.error = "Missing account number or contact ID in profile.";
        this.loading = false;
        return;
      }

      // Initially get all trips, not just pending ones to support all views. Can pass filters :status,policy_triggered,reviewed
      const body = {
        account_number: accountNumber,
        contactId: contactId,
      };

      try {
        const result = await this.$app.huddleLabsServerCall(
          "profile/company-trips",
          body
        );

        if (!result.error) {
          this.trips = result.data;
          this.extractTravelerNames();
        } else {
          this.error = "Error retrieving trips.";
        }
      } catch (err) {
        this.error = "Couldn't fetch company trips.";
        this.$buefy.toast.open({
          message: this.error,
          type: "is-danger",
        });
      } finally {
        this.loading = false;
      }
    },

    applyFilters() {
      // Filters are applied through computed properties
      this.$buefy.toast.open({
        message: "Filters applied",
        type: "is-success",
        duration: 2000,
        position: "is-bottom",
      });
    },

    extractTravelerNames() {
      // Extract unique traveler names for autocomplete
      const uniqueNames = new Set();

      this.trips.forEach((trip) => {
        const fullName = `${trip.firstName} ${trip.lastName}`;
        uniqueNames.add(fullName);
      });

      this.travelerNames = Array.from(uniqueNames).map((name) => ({ name }));
    },

    filterTravelerNames(text) {
      this.filteredTravelerOptions = this.travelerNames.filter((option) => {
        return option.name.toLowerCase().includes(text.toLowerCase());
      });
    },

    formatDate(date) {
      return moment(date).format("ddd, MMM D");
    },

    goToReviewPage(trip) {
      const recordLocator = trip.pnr;
      const bookingId = trip.id;
      const contactId = this.profile.id;

      // Compose a unique key: bookingKey|contactId
      const key = `${trip.bookingKey}|${contactId}`;

      const reviewUrl = `/admin/trip-library/approvals?record_locator=${recordLocator}&booking_id=${bookingId}&key=${key}`;

      window.open(reviewUrl, "_blank");
    },

    goToTripDetail(trip) {

      const recordLocator = trip.pnr;
      //convert Amadeus recordLocator to hash to avoid showing true record locator in the url
      let hash = this.$helpers.encryptText(recordLocator);

      router.push({
        name: "trip-detail",
        params: { recordLocatorHash: hash, tripProp: trip },
      });
    },


    getRowStatusType(trip) {
      if (trip.approved_at) return "is-success";
      if (trip.denied_at) return "is-danger";
      if (!trip.reviewed_at && trip.policy.triggered === "Y")
        return "is-warning";
      return "is-success"; // Default for successful bookings with no policy violations
    },

    getRowStatusText(trip) {
      if (trip.approved_at) return "Approved";
      if (trip.denied_at) return "Denied";
      if (!trip.reviewed_at && trip.policy.triggered === "Y")
        return "Pending Approval";
      return "Success"; // Default for successful bookings with no policy violations
    },

    getPolicyComplianceType(triggered) {
      if (triggered === "Y") return "is-warning";
      if (triggered === "N") return "is-success";
      return "is-light";
    },

    getPolicyComplianceText(triggered) {
      if (triggered === "Y") return "Out of Policy";
      if (triggered === "N") return "In Policy";
      return "Unknown";
    },

    /* Build the policy status based on the applied and triggered values */
    getPolicyStatus(policy) {
      
      // Not applied: applied = N
      if (policy.applied === "N") return "Not Applied";

      // No violations: applied = Y, triggered = N
      if (policy.applied === "Y" && policy.triggered === "N") return "No Violations";

      // x Approval required: applied = Y, triggered = Y, mostStrictApprovalRequired = hard
      // x Passive approval: applied = Y, triggered = Y, mostStrictApprovalRequired = soft
      // x No approval required: applied = Y, triggered = Y, mostStrictApprovalRequired = none
      if (policy.applied === "Y" && policy.triggered === "Y") {
        if (policy.mostStrictApprovalRequired === "hard")
          return "Approval Required";
        if (policy.mostStrictApprovalRequired === "soft")
          return "Passive Approval";
        return "No Approval Required";
      }

      return "Unknown";
    },

    /* Build the policy status type based on the applied and triggered values */
    getPolicyStatusType(policy) {
      
      // Not applied: applied = N
      if (policy.applied === "N") return "is-light";

      // No violations: applied = Y, triggered = N
      if (policy.applied === "Y" && policy.triggered === "N") return "is-success";

      // x Approval required: applied = Y, triggered = Y, mostStrictApprovalRequired = hard
      // x Passive approval: applied = Y, triggered = Y, mostStrictApprovalRequired = soft
      // x No approval required: applied = Y, triggered = Y, mostStrictApprovalRequired = none
      if (policy.applied === "Y" && policy.triggered === "Y") {
        if (policy.mostStrictApprovalRequired === "hard")
          return "is-danger";
        if (policy.mostStrictApprovalRequired === "soft")
          return "is-warning";
        return "is-light";
      }

      return "is-light"; // Default for unknown status
    },


    getApprovalStatus(bookingLog) {
      // Approved: approved_at != null
      if (bookingLog.approved_at) return "Approved";

      // Denied: denied_at != null
      if (bookingLog.denied_at) return "Denied";

      // No review required
      if (!bookingLog.policy.mostStrictApprovalRequired) return "--";

      // No review required
      if (bookingLog.policy.mostStrictApprovalRequired == 'none') return "--";

      return null; // Default for unknown status
    },

    getApprovalStatusType(bookingLog) {
      // Approved: approved_at != null
      if (bookingLog.approved_at) return "is-success";

      // Denied: denied_at != null
      if (bookingLog.denied_at) return "is-danger";

      return "is-light"; // Default for unknown status
    },


    canBeReviewed(bookingLog) {
      return bookingLog.created_at > moment().subtract(3, "days").format("YYYY-MM-DD HH:mm:ss")
    },


    getApprovalLevelType(level) {
      if (!level) return "is-light";

      const typeMap = {
        hard: "is-danger",
        soft: "is-warning",
        info: "is-info",
      };

      return typeMap[level] || "is-light";
    },

    getRulesSummary(rules) {
      if (!rules || rules.length === 0) return "No rules triggered";

      return rules.map((rule) => rule.message).join("\n");
    },

    setActiveTab(tab) {
      this.activeTab = tab;
    },

    resetFilters() {
      this.filters = {
        status: "",
        policyCompliance: "",
        travelerName: "",
        dateRange: [],
      };

      this.$buefy.toast.open({
        message: "Filters reset",
        type: "is-info",
        duration: 2000,
        position: "is-bottom",
      });
    },
  },
  mounted() {
    this.getCompanyTrips();
  },
};
</script>

<style scoped>
.has-text-grey {
  font-size: 1.1em;
}

.subtitle {
  margin-bottom: 1.5rem;
  color: #4a5568;
  font-weight: 500;
}

/* Main Dashboard Container */
.dashboard-container.box {
  border-radius: 8px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  margin-bottom: 2rem;
  background-color: #fff;
}

/* Dashboard Header */
.dashboard-header {
  margin-bottom: 2rem;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 1.5rem;
}

.dashboard-header .title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #363636;
  display: flex;
  align-items: center;
}

.dashboard-header .title .icon {
  margin-right: 0.75rem;
  color: #3273dc;
}

/* Tabs Styling */
.tabs.is-boxed {
  margin-bottom: 2rem;
}

.tabs.is-boxed li a {
  border-radius: 6px 6px 0 0;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.tabs.is-boxed li.is-active a {
  background-color: #f5f9ff;
  border-bottom-color: #f5f9ff;
}

.tabs.is-boxed li:not(.is-active) a:hover {
  background-color: #f9f9f9;
}

.tabs.is-boxed li a .icon {
  margin-right: 0.5rem;
}

/* Tab Content Transitions */
.tab-content-container {
  position: relative;
  transition: all 0.3s ease;
}

.tab-transition-enter-active,
.tab-transition-leave-active {
  transition: opacity 0.3s, transform 0.3s;
  position: absolute;
  width: 100%;
}

.tab-transition-enter,
.tab-transition-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Filter Panel */
.filter-panel {
  background-color: #f9fafc;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.filter-panel .field.label {
  font-weight: 500;
  color: #4a5568;
}

.filter-panel .buttons {
  margin-top: 1rem;
}

/* Enhanced Tables */
.table-container {
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  overflow: hidden; */
}

table.b-table {
  border-radius: 6px;
}

table.b-table th {
  font-weight: 600;
  color: #4a5568;
  background-color: #f8fafc;
  border-bottom: 2px solid #edf2f7;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
}

table.b-table tr:hover {
  background-color: #f5f9ff;
}

table.b-table td {
  vertical-align: middle;
  padding: 0.75rem 1rem;
}

/* Status and Policy Tags */
.b-table .tag {
  font-weight: 500;
  padding: 0.4em 0.75em;
  border-radius: 4px;
}

/* .b-table .tag.is-success {
  background-color: #ebfaeb;
  color: #257925;
} */

/* .b-table .tag.is-warning {
  background-color: #fff8e6;
  color: #946500;
} */

/* .b-table .tag.is-danger {
  background-color: #feecec;
  color: #cc2f2f;
} */

/* .b-table .tag.is-info {
  background-color: #e6f6ff;
  color: #0a66c2;
} */

/* .b-table .tag.is-light {
  background-color: #f9f9f9;
  color: #636363;
} */

/* Improved Empty States */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.empty-state .icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: #d1d5db;
}

.empty-state .empty-state-message {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
  max-width: 24rem;
}

/* Pagination Styling */
.pagination-wrapper {
  margin-top: 1.5rem;
}

.pagination-link.is-current {
  background-color: #3273dc;
  border-color: #3273dc;
}

/* Button Styling */
.button.is-primary {
  transition: background-color 0.2s, transform 0.1s;
}


.button.is-primary:active {
  transform: translateY(1px);
}

/* Tooltip Enhancements */
.b-tooltip .tooltip-content {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

/* Loading State */
.b-loading {
  background-color: rgba(255, 255, 255, 0.7);
}

/* Reports Section */
.reports-section {
  padding: 1rem 0;
}

.reports-section .card {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s, transform 0.2s;
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.reports-section .card:hover {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Responsive Adjustments */
@media screen and (max-width: 768px) {
  .dashboard-container.box {
    padding: 1rem;
  }

  .tabs.is-boxed li a {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .filter-panel {
    padding: 1rem;
  }

  table.b-table th {
    font-size: 0.75rem;
  }

  .b-table .tag {
    font-size: 0.7rem;
  }
}
</style>
